module.exports = __webpack_public_path__ + "img/monitoring-truck-red.a2ddb70e.svg";